"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("../../styles/NavigationPanel");
var VerticalLine = function () {
    return React.createElement("div", { className: styles.navVerticalLine });
};
exports.default = VerticalLine;
//# sourceMappingURL=VerticalLine.js.map